import { Pressable, PressableProps } from 'react-native';

export function AppPressable({ children, ...rest }: PressableProps) {
  return (
    <Pressable {...rest} delayLongPress={20000}>
      {children}
    </Pressable>
  );
}
